<template>
  <div>
    <b-card-body>
      <div class="row mx-md-n3 mx-1 mb-2 align-items-end">
        <div class="col-lg-6 col-sm-7 col-12 mb-sm-0 mb-3">
          <div class="row">
            <div class="col-sm-6 col-12">
              <b-form-group
                label="Data Inicial"
                label-for="movementsStartDate"
                class="mb-sm-0 mb-3"
              >
                <b-form-input
                  id="movementsStartDate"
                  v-model="movementsStartDateStr"
                  required
                  type="date"/>
              </b-form-group>
            </div>
            <div class="col-sm-6 col-12">
              <b-form-group
                label="Data Final"
                label-for="movementsEndDate"
                class="mb-0"
              >
                <b-form-input
                  id="movementsEndDate"
                  v-model="movementsEndDateStr"
                  required
                  type="date"/>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-sm-auto col-6">
          <b-dropdown text="Filtros" class="mobile-btn-100">
            <b-dropdown-form>
              <b-form-group
                label="Documento"
                label-for="historySearchText"
              >
                <b-form-input
                  id="historySearchText"
                  v-model="historySearchText"
                  @keyup.enter="historySearchButtonPressed"
                  placeholder="Procurar por..."
                />
              </b-form-group>
              <b-form-group
                label="Endereço"
              >
                <div v-if="locationsFilter.loading">
                  <loading-animation />
                </div>
                <model-list-select
                  :list="locationsFilter.locations"
                  option-value="id"
                  option-text="name"
                  v-model="movementsSelectedLocation"
                  placeholder="Endereço"
                  @searchchange="locationsFilterChanged"
                  :filterPredicate="alwaysTrueFilterPredicate"
                />
              </b-form-group>
              <b-form-group
                label="Armazém"
              >
                <div v-if="loadingWarehouses">
                  <loading-animation />
                </div>
                <model-list-select
                  :list="warehouses"
                  option-value="id"
                  option-text="name"
                  v-model="movementsSelectedWarehouse"
                  placeholder="Armazém"
                />
              </b-form-group>
              <b-form-group
                label="Lote"
              >
                <div v-if="lotsFilter.loading">
                  <loading-animation />
                </div>
                <model-list-select
                  :list="lotsFilter.lots"
                  option-value="id"
                  option-text="lotNumber"
                  v-model="movementsSelectedLot"
                  placeholder="Digite para pesquisar"
                  @searchchange="searchLots"
                  :filterPredicate="alwaysTrueFilterPredicate"
                />
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-6">
          <button @click="movementsSearchButtonPressed" type="button" class="btn btn-primary mobile-btn-100">Buscar</button>
        </div>
      </div>

      <div v-if="movementsAppliedFilters.length" class="row mb-2 mx-0">
        <div v-for="(filter, index) in movementsAppliedFilters" class="col-auto px-1" :key="index">
          <h5>
            <span class="badge badge-warning">{{filter.label}} = {{filter.value}}</span>
          </h5>
        </div>
      </div>

      <h3 v-if="!hasAnyMovementFilter" class="mx-md-0 mx-3 text-right mb-2 pb-1">Saldo anterior: {{previousBalance}}</h3>

      <div class="row mx-md-n3 mx-1">
        <b-col sm="12">
          <div v-if="loadingItemLotMovements" class="mb-5 pb-5">
            <loading-animation />
          </div>

          <div v-if="!loadingItemLotMovements && (!item.itemLotMovements || !item.itemLotMovements.length)" class="mb-3">
            <div class="row bg-light mx-0 py-3">
              <div class="col text-center">
                Nenhum movimento encontrado para a pesquisa
              </div>
            </div>
          </div>

          <div v-if="!loadingItemLotMovements && item.itemLotMovements && item.itemLotMovements.length" class="mb-3">
            <div v-for="(item, index) in item.itemLotMovements" class="row py-3 border mx-0" :key="index"
              :class="{ 'bg-light': index % 2 != 0 }">
              <div class="col-xl-4 col-lg-12 col-md-12 col-sm-6 col-12">
                <div class="row">
                  <div class="col-xl-12 col-md-4 col-12">
                    <span class="font-weight-bold">Data: </span>{{item.formattedDate}}
                  </div>
                  <div class="col-xl-12 col-md-4 col-12">
                    <span class="font-weight-bold">Documento: </span>
                    {{item.orderItem && item.orderItem.order ? item.orderItem.order.number : ''}}
                    <span v-if="item.orderItem && item.orderItem.order && item.orderItem.order.fiscalOperation" class="badge ml-1"
                      :class="operationBadgeClassObject(item)">
                      {{item.orderItem.order.fiscalOperation.showType}}
                    </span>
                  </div>
                  <div class="col-xl-12 col-md-4 col-12">
                    <span class="font-weight-bold">Pessoa: </span>
                    {{item.orderItem && item.orderItem.order && item.orderItem.order.customer && item.orderItem.order.customer.person ? item.orderItem.order.customer.person.name : ''}}
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="row">
                  <div class="col-12">
                    <span class="font-weight-bold">Número do Lote: </span>{{item.itemLot ? item.itemLot.lotNumber : ''}}
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">Endereço: </span>{{item.location ? item.location.name : ''}}
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-7 col-12">
                <div class="row">
                  <div class="col-4">
                    <span class="font-weight-bold">Entradas</span><br>
                    <composite-item-lot-quantity
                      v-if="item.type === 'ENT'"
                      :quantity="item.quantity"
                      :itemLot="item.itemLot"
                    ></composite-item-lot-quantity>
                  </div>
                  <div class="col-4">
                    <span class="font-weight-bold">Saídas</span><br>
                    <composite-item-lot-quantity
                      v-if="item.type === 'SAI'"
                      :quantity="item.quantity"
                      :itemLot="item.itemLot"
                    ></composite-item-lot-quantity>
                  </div>
                  <div v-if="!hasAnyMovementFilter" class="col-4">
                    <span class="font-weight-bold">Saldo</span><br>{{item.balance}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <nav>
            <b-pagination
              align="center"
              :limit="10"
              :total-rows="movementsTotalRows"
              :per-page="movementsPerPage"
              prev-text="Anterior"
              next-text="Próximo"
              number-of-page="numberOfPages"
              v-model="movementsCurrentPage"
              @change="movementsPageChanged"
              :disabled="loadingItemLotMovements"/>
          </nav>
        </b-col>
      </div>
    </b-card-body>
  </div>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders';
  import { ModelListSelect } from 'vue-search-select';
  import shared from '@/shared/shared';
  import { httpClient } from '@/service';
  import CompositeItemLotQuantity from '@/components/common/composite-item-lot-quantity';

  export default {
    name: 'item-movements',
    components: {
      LoadingAnimation,
      ModelListSelect,
      CompositeItemLotQuantity
    },

    props: {
      item: {
        type: Object,
        required: true
      },
      loadingWarehouses: {
        type: Boolean,
        required: true
      },
      warehouses: {
        type: Array,
        required: true
      },
      alwaysTrueFilterPredicate: {
        type: Function,
        required: true
      },
      locationsFilter: {
        type: Object,
        required: true
      },
      lotsFilter: {
        type: Object,
        required: true
      },
      searchLocations: {
        type: Function,
        required: true
      },
      searchLots: {
        type: Function,
        required: true
      },
      updateItem: {
        type: Function,
        required: true
      }
    },

    data () {
      return {
        itemLotMovementsSearched: false,
        movement: {
          totalIn: 0,
          totalOut: 0,
          reallocation: 0,
        },
        previousBalance: 0,
        movementsStartDateStr: '',
        movementsEndDateStr: '',
        loadingItemLotMovements: false,
        movementsSelectedWarehouse: {},
        movementsSelectedLocation: {},
        movementsSelectedLot: {},
        movementsCurrentPage: 1,
        movementsPerPage: 10,
        movementsTotalRows: 10,
        historySearchText: null,
        hasAnyMovementFilter: false,
      }
    },

    beforeMount: function () {
      let today = new Date();
      let thisMonthMinus3 = new Date();
      thisMonthMinus3.setMonth(thisMonthMinus3.getMonth() - 3);

      this.movementsStartDateStr = thisMonthMinus3.toJSON().substring(0, 10);
      this.movementsEndDateStr = today.toJSON().substring(0, 10);

      this.movementsSelectedLot = shared.getLocalStorageObj('items/show/Movements/movementsSelectedLot', this.movementsSelectedLot);
      this.movementsSelectedLocation = shared.getLocalStorageObj('items/show/Movements/movementsSelectedLocation', this.movementsSelectedLocation);
      this.movementsSelectedWarehouse = shared.getLocalStorageObj('items/show/Movements/movementsSelectedWarehouse', this.movementsSelectedWarehouse);
      this.historySearchText = shared.getLocalStorageString('items/show/Movements/historySearchText', this.historySearchText);
    },

    computed: {
      movementsAppliedFilters() {
        let appliedFilters = [];

        if (this.movementsStartDateStr && this.movementsStartDateStr.length) {
          appliedFilters.push({ label: 'Data Inicial', value: shared.formatDate(this.movementsStartDateStr + 'T00:00:00', { dateOnly: true }) });
        }

        if (this.movementsEndDateStr && this.movementsEndDateStr.length) {
          appliedFilters.push({ label: 'Data Final', value: shared.formatDate(this.movementsEndDateStr + 'T00:00:00', { dateOnly: true }) });
        }

        if (this.historySearchText && this.historySearchText.length) {
          appliedFilters.push({ label: 'Documento', value: this.historySearchText });
        }

        if (this.movementsSelectedLocation && this.movementsSelectedLocation.id) {
          appliedFilters.push({ label: 'Endereço', value: this.movementsSelectedLocation.name });
        }

        if (this.movementsSelectedWarehouse && this.movementsSelectedWarehouse.id) {
          appliedFilters.push({ label: 'Armazém', value: this.movementsSelectedWarehouse.name });
        }

        if (this.movementsSelectedLot && this.movementsSelectedLot.id) {
          appliedFilters.push({ label: 'Lote', value: this.movementsSelectedLot.lotNumber });
        }

        return appliedFilters;
      }
    },

    methods: {
      tabChanged() {
        if (!this.itemLotMovementsSearched) {
          this.getItemLotMovements();
          this.itemLotMovementsSearched = true;
        }
      },

      historySearchButtonPressed() {
        this.movementsCurrentPage = 1;
        this.getItemLotMovements();
      },

      locationsFilterChanged($event) {
        this.searchLocations($event, conditions => {
          if (this.movementsSelectedWarehouse && this.movementsSelectedWarehouse.id) {
            conditions.push({
              field: 'stockLocale.id',
              value: this.movementsSelectedWarehouse.id
            });
          }

          return conditions;
        });
      },

      movementsPageChanged(page) {
        this.movementsCurrentPage = page;
        this.getItemLotMovements();
      },

      movementsSearchButtonPressed() {
        this.movementsCurrentPage = 1;
        this.getItemLotMovements();
      },

      getItemLotMovements() {
        if (this.loadingItemLotMovements) {
          return;
        }

        this.hasAnyMovementFilter = (this.historySearchText && this.historySearchText.length)
          || (this.movementsSelectedLocation && this.movementsSelectedLocation.id)
          || (this.movementsSelectedWarehouse && this.movementsSelectedWarehouse.id)
          || (this.movementsSelectedLot && this.movementsSelectedLot.id);

        this.loadingItemLotMovements = true;

        let additionalConditions = [];

        if (this.historySearchText && this.historySearchText.length) {
          additionalConditions.push({
            field: 'orderItem.order.number',
            value: this.historySearchText
          });
        }

        shared.setLocalStorageString('items/show/Movements/historySearchText', this.historySearchText);

        if (this.movementsSelectedWarehouse && this.movementsSelectedWarehouse.id) {
          additionalConditions.push({
            field: 'location.stockLocale.id',
            value: this.movementsSelectedWarehouse.id
          });
        }

        shared.setLocalStorageObj('items/show/Movements/movementsSelectedWarehouse', this.movementsSelectedWarehouse);

        if (this.movementsSelectedLocation && this.movementsSelectedLocation.id) {
          additionalConditions.push({
            field: 'location.id',
            value: this.movementsSelectedLocation.id
          });
        }

        shared.setLocalStorageObj('items/show/Movements/movementsSelectedLocation', this.movementsSelectedLocation);

        if (this.movementsSelectedLot && this.movementsSelectedLot.id) {
          additionalConditions.push({
            field: 'itemLot.id',
            value: this.movementsSelectedLot.id
          });
        }

        shared.setLocalStorageObj('items/show/Movements/movementsSelectedLot', this.movementsSelectedLot);

        shared.setLocalStorageString('items/show/Movements/movementsStartDateStr', this.movementsStartDateStr);

        shared.setLocalStorageString('items/show/Movements/movementsEndDateStr', this.movementsEndDateStr);


        httpClient
        .post(`${process.env.VUE_APP_API_URL}item-lot-movements/item/${this.item.id}?page=${this.movementsCurrentPage - 1}&size=${this.movementsPerPage}&sort=createdAt,asc`, {
          startDate: this.movementsStartDateStr + 'T00:00:00.000Z',
          endDate: this.movementsEndDateStr + 'T23:59:59.999Z',
          additionalConditions: additionalConditions
        })
        .then(({ data }) => {
          this.loadingItemLotMovements = false;
          this.item.itemLotMovements = data.data.content;
          this.movementsTotalRows = data.data.totalElements;

          if (this.item.itemLotMovements) {
            this.item.itemLotMovements.forEach(itemLotMovement => {
              itemLotMovement.formattedDate = shared.formatDate(itemLotMovement.createdAt);

              if (itemLotMovement.orderItem && itemLotMovement.orderItem.order && itemLotMovement.orderItem.order.fiscalOperation) {
                if (itemLotMovement.orderItem.order.transfer) {
                  itemLotMovement.orderItem.order.fiscalOperation.showType = 'TRANSFERENCIA';
                } if (itemLotMovement.orderItem.order.transformationMS) {
                  itemLotMovement.orderItem.order.fiscalOperation.showType = 'TRANSFORMACAO';
                } if (itemLotMovement.orderItem.order.productionMS) {
                  itemLotMovement.orderItem.order.fiscalOperation.showType = 'PRODUCAO';
                } else if (itemLotMovement.orderItem.order.stockAdjustment) {
                  itemLotMovement.orderItem.order.fiscalOperation.showType = 'AJU';
                } else if (itemLotMovement.orderItem.order.fiscalOperation) {
                  itemLotMovement.orderItem.order.fiscalOperation.showType = itemLotMovement.orderItem.order.fiscalOperation.type;
                }
              }
            })
          }

          this.updateItem(this.item);

          if (data.meta) {
            this.previousBalance = data.meta.previousBalance;
          }

          if (!this.previousBalance) {
            this.previousBalance = 0;
          }
        })
        .catch((error) => {
          this.loadingItemLotMovements = false;
          if (error.message) {
            this.$notify.error(error)
          }

          this.item.itemLotMovements = []
        });
      },

      operationBadgeClassObject(ilm) {
        if (ilm.orderItem && ilm.orderItem.order) {
          return shared.operationBadgeClassObject(ilm.orderItem.order);
        } else {
          return '';
        }
      },
    },

    watch: {
      'movementsSelectedWarehouse': function(newVal, oldVal) {
        if (!shared.entitiesAreEqual(newVal, oldVal)) {
          this.locationsFilter.locations = [];
        }
      }
    }
  }
</script>

<style scoped>
</style>
